import { createContext, useContext } from 'react';

/*
 * Toast API. The host (components/shared/Toast.tsx) owns the state and the
 * single element; screens only call these two functions.
 *
 *   toast(msg)            — 2.4 s notice (`toast(msg, ms)` for a longer one)
 *   toastUndo(msg, undo)  — 5 s notice with an Undo button; removing a line
 *                           is one tap, so undoing it has to be one tap too
 */
export interface ToastApi {
  toast: (message: string, ms?: number) => void;
  toastUndo: (message: string, undo: () => void) => void;
  /** Hides whatever is showing (and drops a pending undo). */
  dismiss: () => void;
}

export const TOAST_MS = 2400;
export const TOAST_UNDO_MS = 5000;

export const ToastCtx = createContext<ToastApi | null>(null);

export function useToast(): ToastApi {
  const ctx = useContext(ToastCtx);
  if (!ctx) throw new Error('useToast must be used inside <ToastProvider>');
  return ctx;
}
